require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-07-treasures-of-the-past-promises-of-the-future.json") })
        }
      }, "path---articles-2008-07-treasures-of-the-past-promises-of-the-future");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-07-treasures-of-the-past-promises-of-the-future!./.cache/json/articles-2008-07-treasures-of-the-past-promises-of-the-future.json
// module id = 382
// module chunks = 231608221292675